var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.all_properties),callback:function ($$v) {_vm.all_properties=$$v},expression:"all_properties"}}),_c('div',{attrs:{"id":"propertyPaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }